// extracted by mini-css-extract-plugin
export var borderbottom = "SectionDogBio-module--borderbottom--c6352";
export var bordersection = "SectionDogBio-module--bordersection--119ae";
export var contentsection = "SectionDogBio-module--contentsection--da0a3";
export var dogbiofieldcontainer = "SectionDogBio-module--dogbiofieldcontainer--644f4";
export var dogbiofields = "SectionDogBio-module--dogbiofields--c2f61";
export var dogbiofieldsfirst = "SectionDogBio-module--dogbiofieldsfirst--f84e6";
export var dogbiofieldssecond = "SectionDogBio-module--dogbiofieldssecond--876bf";
export var dogbioinner = "SectionDogBio-module--dogbioinner--96312";
export var dogbioinnerireland = "SectionDogBio-module--dogbioinnerireland--64e29 SectionDogBio-module--dogbioinner--96312";
export var dogisreserved = "SectionDogBio-module--dogisreserved--8ffd6 SectionDogBio-module--dogisunderdog--f1de1";
export var dogisunderdog = "SectionDogBio-module--dogisunderdog--f1de1";
export var favourite = "SectionDogBio-module--favourite--35149";
export var firstsection = "SectionDogBio-module--firstsection--abe67";
export var headingsection = "SectionDogBio-module--headingsection--d5529";
export var headingsectionwithlabel = "SectionDogBio-module--headingsectionwithlabel--799e3";
export var icon = "SectionDogBio-module--icon--83a56";
export var secondsection = "SectionDogBio-module--secondsection--f2bb7";
export var sizeguide = "SectionDogBio-module--sizeguide--42a98";
export var sizeguidecontent = "SectionDogBio-module--sizeguidecontent--eda2b";
export var tagicon = "SectionDogBio-module--tagicon--6c63f";
export var text = "SectionDogBio-module--text--f8750";
export var textarea = "SectionDogBio-module--textarea--a6c21";
export var title = "SectionDogBio-module--title--db51c";
export var value = "SectionDogBio-module--value--ee0fa";